import React, { useContext } from "react";
import { useSelector } from "react-redux";
import { makeStyles } from "@material-ui/styles";
import DialogActions from "@material-ui/core/DialogActions";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import { AppContext, TOGGLE_SETTINGS } from "../Context";
import { setCookie } from "../Actions/cookiesActions";
import { THEME, STATE_CULTURE } from "../Actions/stateActions";
import { LANGUAGE_LOADED } from "../Actions/actionTypes";
import sv from "../Images/sv-SE.svg";
import en from "../Images/en-US.svg";
import { Modal, Button } from "@mantine/core";
import { FormControl, FormLabel, Radio, RadioGroup } from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
  modalWrapper: {
    background: theme.app.background[1],
  },
  settingsTitle: {
    fontSize: "1.5rem !important",
    marginTop: "1rem",
  },
  contentSection: {
    marginBottom: "16px",
  },
  contentHeading: {
    color: theme.app.labelColor,
    fontSize: "1.125rem !important",
  },
  button: { color: theme.app.labelColor },
  group: {
    flexDirection: "row",
  },
  label: {
    display: "flex",
    alignItems: "center",
  },
  flag: {
    width: "23px",
    height: "23px",
    marginRight: "4px",
    borderRadius: "7px",
  },
  labelText: { fontSize: "0.8125rem", color: theme.app.labelColor },
  content: {
    color: theme.app.labelColor,
  },
  closeButton: {
    color: theme.app.labelColor,
  },
  noPadding: {
    padding: 0,
  },
  formLabel: {
    color: theme.app.labelColor,
  },
}));

const Settings = (props) => {
  const classes = useStyles();
  const context = useContext(AppContext);
  const { theme, culture, language } = useSelector((state) => ({
    theme: state.cookies[THEME],
    culture: state.cookies[STATE_CULTURE],
    language: state.language,
  }));
  const { state, dispatch, rdxDispatch } = context;
  const { settingsOpen } = state;
  const closeDialog = () => dispatch({ type: TOGGLE_SETTINGS });
  const setTheme = (theme) => rdxDispatch(setCookie(THEME, theme));
  const setCulture = (culture) => {
    rdxDispatch(setCookie(STATE_CULTURE, culture));
    fetch(process.env.PUBLIC_URL + `/language.${culture}.json`)
      .then((response) => {
        return response.json();
      })
      .then((json) => {
        rdxDispatch({
          type: LANGUAGE_LOADED,
          payload: json,
        });
      });
  };

  const SwedishLabel = () => (
    <span className={classes.label}>
      <img src={sv} className={classes.flag} alt={language.swedishFlag} />
      <span>Svenska</span>
    </span>
  );
  const EnglishLabel = () => (
    <span className={classes.label}>
      <img src={en} className={classes.flag} alt={language.englishFlag} />
      <span lang="en">English</span>
    </span>
  );

  return (
    <Modal
      opened={settingsOpen}
      onClose={closeDialog}
      style={{ zIndex: 9998 }}
      closeButtonLabel={language.closeMenu}
      title={language.settings}
      centered
      size="lg"
      classNames={{
        modal: classes.modalWrapper,
        title: classes.content,
        close: classes.closeButton,
        inner: classes.noPadding,
      }}
    >
      <main className={classes.content}>
        <div className={classes.contentSection}>
          <FormControl component="fieldset">
            <FormLabel component="legend" className={classes.formLabel}>
              {language.changeLanguage}
            </FormLabel>
            <RadioGroup
              id="language-settings-radio"
              className={classes.group}
              value={culture}
              onChange={(e) => setCulture(e.target.value)}
            >
              <FormControlLabel
                classes={{ label: classes.labelText }}
                value="sv-SE"
                control={<Radio name="language-settings" />}
                label={<SwedishLabel />}
                aria-label={language.swedish}
              />
              <FormControlLabel
                classes={{ label: classes.labelText }}
                value="en-US"
                control={<Radio name="language-settings" />}
                label={<EnglishLabel />}
                aria-label={language.english}
              />
            </RadioGroup>
          </FormControl>
        </div>
        <div className={classes.contentSection}>
          <FormControl component="fieldset">
            <FormLabel component="legend" className={classes.formLabel}>
              {language.changeTheme}
            </FormLabel>
            <RadioGroup
              aria-label={language.changeTheme}
              className={classes.group}
              value={theme}
              onChange={(e) => setTheme(e.target.value)}
            >
              <FormControlLabel
                classes={{ label: classes.labelText }}
                value="light"
                control={<Radio />}
                label={language.themeLight}
                aria-label={language.themeLight}
              />
              <FormControlLabel
                classes={{ label: classes.labelText }}
                value="dark"
                control={<Radio />}
                label={language.themeDark}
                aria-label={language.themeDark}
              />
              <FormControlLabel
                classes={{ label: classes.labelText }}
                value="darkest"
                control={<Radio />}
                label={language.themeDarkest}
                aria-label={language.themeDarkest}
              />
            </RadioGroup>
          </FormControl>
        </div>
        <DialogActions>
          <Button
            className="primaryButton"
            size="sm"
            variant="filled"
            color="violet.9"
            onClick={closeDialog}
            aria-label={language.closeMenu}
          >
            {language.close}
          </Button>
        </DialogActions>
      </main>
    </Modal>
  );
};

export default Settings;
